import React, { ReactNode } from 'react';

/**
 * 卡片组件属性接口
 */
export interface CardProps {
  /** 卡片内容 */
  children: ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 卡片大小变体 */
  size?: 'small' | 'medium' | 'large';
  /** 是否有悬停效果 */
  hoverable?: boolean;
  /** 是否有边框 */
  bordered?: boolean;
  /** 卡片圆角大小 */
  radius?: 'small' | 'medium' | 'large';
  /** 卡片内边距大小 */
  padding?: 'none' | 'small' | 'medium' | 'large';
}

/**
 * 通用卡片组件
 * 提供统一的卡片样式，可用于整个网站的各种卡片场景
 * @param {CardProps} props - 组件属性
 * @returns {JSX.Element} 渲染的React组件
 */
const Card: React.FC<CardProps> = ({ 
  children, 
  className = '',
  size = 'medium',
  hoverable = false,
  bordered = true,
  radius = 'medium',
  padding = 'medium'
}) => {
  // 根据size属性设置卡片大小相关样式
  const sizeClasses = {
    small: '',
    medium: '',
    large: ''
  };

  // 根据radius属性设置卡片圆角样式
  const radiusClasses = {
    small: 'rounded-lg',
    medium: 'rounded-xl',
    large: 'rounded-2xl'
  };

  // 根据padding属性设置卡片内边距样式
  const paddingClasses = {
    none: '',
    small: 'p-4',
    medium: 'p-6',
    large: 'p-8'
  };

  // 组合所有样式类
  const cardClasses = [
    'bg-white',
    radiusClasses[radius],
    paddingClasses[padding],
    sizeClasses[size],
    bordered ? 'border border-gray-100' : '',
    hoverable ? 'transition-all duration-300 hover:border-gray-200' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      {children}
    </div>
  );
};

export default Card;